import { downloadExcelOfUsers, getDashboardData, getUserDetails, getUsers, usersLogin, verifyEmail, updateUser, getUserBankDetails, getUserLedgers, depositToUser, userWithdrawalRequests, approveWithdrawal, rejectWithdrawal, getPlatformBalances, getUserAssets, getAutoTransaction, getDepositFees, updateDepositFees, getTradeFees, approveAchWithdrawal, rejectAchWithdrawal, listPlatformFees, getCountries, getUseractivity, getC2CCrypto, updateC2CCrypto, getUserOverview, approveReferralDeposit, rejectReferralDeposit, getReferralSummary, getIncompleteOnboardingUsers, deleteIncompleteOnboardingUser, getUserSpinHistory, adjustSpins, getAdminAllSpins, exportPlatformBalances, exportUsersTransactions, getSpinConfigStatus, getAuditLogs, downloadAuditLogsExcel } from './ApiEndPoint'
import { baseApiCall } from './BaseApiCall'
import { pushApiCall } from './PushApiCall'
import type { PushRequestOptions } from './PushApiCall'
import { pushAudienceLocations, pushAudiencePreview, pushAudienceUsers, pushCampaigns, pushCampaignTest, pushDestinations, pushGroups, pushUserHistory } from './ApiEndPoint'

export const ApiUsersLogin = (data: any) => {
  return baseApiCall({
    url: usersLogin,
    method: 'post',
    data
  })
}

export const ApiVerifyEmail = (data: any) => {
  return baseApiCall({
    url: verifyEmail,
    method: 'post',
    data
  })
}

export const ApiGetUsers = (data: any) => {
  return baseApiCall({
    url: getUsers + data,
    method: 'get',
  })
}

export const ApiGetDashboardData = (data: any) => {
  return baseApiCall({
    url: getDashboardData + data,
    method: 'get',
  })
}

export const ApiGetUsersExcel = (data: any) => {
  return baseApiCall({
    url: downloadExcelOfUsers + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiGetUserDetails = (data: any) => {
  return baseApiCall({
    url: getUserDetails + data,
    method: 'get',
  })
}

export const ApiUpdateUser = (data: any) => {
  return baseApiCall({
    url: updateUser,
    method: 'put',
    data
  })
}

export const ApiGetUserBankDetails = (data: any) => {
  return baseApiCall({
    url: getUserBankDetails + data,
    method: 'get',
  })
}

export const ApiGetLedger = (data: any) => {
  return baseApiCall({
    url: getUserLedgers + data,
    method: 'get',
  })
}

export const ApiDepositToUser = (data: any) => {
  return baseApiCall({
    url: depositToUser,
    method: 'post',
    data
  })
}

export const ApiGetWithdrawalRequests = (data: any) => {
  return baseApiCall({
    url: userWithdrawalRequests + data,
    method: 'get',
  })
}

export const ApiApproveWithdrawal = (data: any) => {
  return baseApiCall({
    url: approveWithdrawal,
    method: 'post',
    data
  })
}

export const ApiRejectWithdrawal = (data: any) => {
  return baseApiCall({
    url: rejectWithdrawal,
    method: 'post',
    data
  })
}

export const ApiGetPlatformBalances = (data: any) => {
  return baseApiCall({
    url: getPlatformBalances + data,
    method: 'get',
  })
}

export const ApiGetUserAssets = (data: any) => {
  return baseApiCall({
    url: getUserAssets + data,
    method: 'get',
  })
}

export const ApiGetAutoTransaction = (data: any) => {
  return baseApiCall({
    url: getAutoTransaction + data,
    method: 'get',
  })
}

export const ApiGetDepositFees = (data: any) => {
  return baseApiCall({
    url: getDepositFees + data,
    method: 'get',
  })
}

export const ApiUpdateDepositFees = (data: any) => {
  return baseApiCall({
    url: updateDepositFees,
    method: 'put',
    data
  })
}
export const ApiGetTradeFees = async (data: any) => {
  return baseApiCall({
    url: getTradeFees + data,
    method: 'get',
  })
}

export const ApiApproveAchWithdrawal = (data: any) => {
  return baseApiCall({
    url: approveAchWithdrawal,
    method: 'post',
    data
  })
}

export const ApiRejectAchWithdrawal = (data: any) => {
  return baseApiCall({
    url: rejectAchWithdrawal,
    method: 'post',
    data
  })
}

export const ApiListPlatformFees = (data: string) => {
  return baseApiCall({
    url: listPlatformFees + data,
    method: 'get',
  })
}

export const ApiCreatePlatformFee = (data: any) => {
  return baseApiCall({
    url: listPlatformFees,
    method: 'post',
    data
  })
}

export const ApiUpdatePlatformFee = (id: string, data: any) => {
  return baseApiCall({
    url: `${listPlatformFees}/${id}`,
    method: 'patch',
    data
  })
}

export const ApiUpdatePlatformFeeStatus = (id: string, data: { isActive: boolean }) => {
  return baseApiCall({
    url: `${listPlatformFees}/${id}/status`,
    method: 'patch',
    data
  })
}

export const ApiDeletePlatformFee = (id: string) => {
  return baseApiCall({
    url: `${listPlatformFees}/${id}`,
    method: 'delete',
  })
}

export const ApiResolvePlatformFee = (countryCode: string, stateCode?: string) => {
  const qs = stateCode ? `?stateCode=${stateCode}` : ''
  return baseApiCall({
    url: `${listPlatformFees}/resolve?countryCode=${countryCode}${qs}`,
    method: 'get',
  })
}

export const ApiGetCountries = () => {
  return baseApiCall({
    url: getCountries,
    method: 'get',
  })
}

export const ApiGetStates = (countryCode: string) => {
  return baseApiCall({
    url: `${getCountries}/${countryCode}/states`,
    method: 'get',
  })
}

export const ApiGetUserActivity = (data: any) => {
  return baseApiCall({
    url: getUseractivity + data,
    method: 'get',
  })
}

export const ApiGetC2CTradableCryptos = (data: any) => {
  return baseApiCall({
    url: getC2CCrypto + data,
    method: 'get',
  })
}

export const ApiUpdateC2CTradable = (id: string, data: { c2cTradable: boolean }) => {
  return baseApiCall({
    url: `${updateC2CCrypto}/${id}`,
    method: 'patch',
    data
  })
}

export const ApiGetAllUsersTransactions = (data: any) => {
  return baseApiCall({
    url: getUserOverview + data,
    method: 'get',
  })
}

export const ApiApproveReferralDeposit = (data: any) => {
  return baseApiCall({
    url: `${approveReferralDeposit}`,
    method: 'post',
    data
  })
}

export const ApiRejectReferralDeposit = (data: any) => {
  return baseApiCall({
    url: `${rejectReferralDeposit}`,
    method: 'post',
    data
  })
}

export const ApiGetReferralSummary = (userId: string, data: any) => {
  return baseApiCall({
    url: `${getReferralSummary}/${userId}` + data,
    method: 'get',
  })
}

export const ApiGetIncompleteOnboardingUsers = (data: any) => {
  return baseApiCall({
    url: `${getIncompleteOnboardingUsers}` + data,
    method: 'get',
  })
}

export const ApiDeleteIncompleteOnboardingUser = (userId: string) => {
  return baseApiCall({
    url: `${deleteIncompleteOnboardingUser}/${userId}`,
    method: 'delete',
  })
}

export const ApiGetUserSpinHistory = (userId: any, data: any) => {
  return baseApiCall({
    url: `${getUserSpinHistory}/${userId}/spin-history` + data,
    method: 'get',
  })
}

export const ApiAdjustSpins = (data: any) => {
  return baseApiCall({
    url: `${adjustSpins}`,
    method: 'post',
    data
  })
}

export const ApiGetAdminAllSpins = (data: any) => {
  return baseApiCall({
    url: `${getAdminAllSpins}` + data,
    method: 'get',
  })
}

export const ApiExportPlatformBalances = (data: any) => {
  return baseApiCall({
    url: exportPlatformBalances + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiExportUsersTransactions = (data: any) => {
  return baseApiCall({
    url: exportUsersTransactions + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiGetSpinConfigStatus = () => {
  return baseApiCall({
    url: `${getSpinConfigStatus}`,
    method: 'get',
  })
}

export const ApiGetAuditLogs = (data: any) => {
  return baseApiCall({
    url: `${getAuditLogs}` + data,
    method: 'get',
  })
}

export const ApiDownloadAuditLogsExcel = (data: any) => {
  return baseApiCall({
    url: downloadAuditLogsExcel + data,
    method: 'get',
    responseType: 'blob'
  })
}

export const ApiPushDestinations = () => {
  return pushApiCall({ url: pushDestinations, method: 'get' })
}

export const ApiPushSearchUsers = (query: string, options?: PushRequestOptions) => {
  return pushApiCall({ url: pushAudienceUsers + query, method: 'get' }, options)
}

export const ApiPushLocations = () => {
  return pushApiCall({ url: pushAudienceLocations, method: 'get' })
}

export const ApiPushPreviewAudience = (audience: any, options?: PushRequestOptions) => {
  return pushApiCall({ url: pushAudiencePreview, method: 'post', data: { audience } }, options)
}

export const ApiPushGetGroups = (query: string, options?: PushRequestOptions) => {
  return pushApiCall({ url: pushGroups + query, method: 'get' }, options)
}

export const ApiPushGetGroup = (id: string, options?: PushRequestOptions) => {
  return pushApiCall({ url: `${pushGroups}/${id}`, method: 'get' }, options)
}

export const ApiPushCreateGroup = (data: any) => {
  return pushApiCall({ url: pushGroups, method: 'post', data })
}

export const ApiPushUpdateGroup = (id: string, data: any) => {
  return pushApiCall({ url: `${pushGroups}/${id}`, method: 'patch', data })
}

export const ApiPushDeleteGroup = (id: string) => {
  return pushApiCall({ url: `${pushGroups}/${id}`, method: 'delete' })
}

export const ApiPushGetGroupMembers = (id: string, query: string, options?: PushRequestOptions) => {
  return pushApiCall({ url: `${pushGroups}/${id}/members${query}`, method: 'get' }, options)
}

export const ApiPushAddGroupMembers = (id: string, userIds: string[]) => {
  return pushApiCall({ url: `${pushGroups}/${id}/members`, method: 'post', data: { userIds } })
}

export const ApiPushRemoveGroupMembers = (id: string, userIds: string[]) => {
  return pushApiCall({ url: `${pushGroups}/${id}/members/remove`, method: 'post', data: { userIds } })
}

export const ApiPushGetCampaigns = (query: string, options?: PushRequestOptions) => {
  return pushApiCall({ url: pushCampaigns + query, method: 'get' }, options)
}

export const ApiPushGetCampaign = (id: string, options?: PushRequestOptions) => {
  return pushApiCall({ url: `${pushCampaigns}/${id}`, method: 'get' }, options)
}

export const ApiPushCreateCampaign = (data: any) => {
  return pushApiCall({ url: pushCampaigns, method: 'post', data })
}

export const ApiPushSendTest = (data: any) => {
  return pushApiCall({ url: pushCampaignTest, method: 'post', data })
}

export const ApiPushCampaignReuse = (id: string, options?: PushRequestOptions) => {
  return pushApiCall({ url: `${pushCampaigns}/${id}/reuse`, method: 'get' }, options)
}

export const ApiPushRetryFailed = (id: string) => {
  return pushApiCall({ url: `${pushCampaigns}/${id}/retry-failed`, method: 'post' })
}

export const ApiPushCancelCampaign = (id: string) => {
  return pushApiCall({ url: `${pushCampaigns}/${id}/cancel`, method: 'post' })
}

export const ApiPushGetRecipients = (id: string, query: string, options?: PushRequestOptions) => {
  return pushApiCall({ url: `${pushCampaigns}/${id}/recipients${query}`, method: 'get' }, options)
}

export const ApiPushGetRecipient = (id: string, userId: string) => {
  return pushApiCall({ url: `${pushCampaigns}/${id}/recipients/${userId}`, method: 'get' }, { silent: true })
}

export const ApiPushUserHistory = (userId: string, query: string) => {
  return pushApiCall({ url: `${pushUserHistory}/${userId}/history${query}`, method: 'get' })
}

export const ApiPushExportCampaign = (id: string) => {
  return pushApiCall({ url: `${pushCampaigns}/${id}/export`, method: 'get', responseType: 'blob' }, { raw: true })
}
